import { render, staticRenderFns } from "./EntityDialog.vue?vue&type=template&id=46c680a2&"
import script from "./EntityDialog.vue?vue&type=script&lang=js&"
export * from "./EntityDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports